import { gql } from '@apollo/client';

export { idempotencyContext } from '@/modules/clinical-records/clinical.gql';

export const APPOINTMENT_FIELDS = gql`
  fragment AppointmentFields on Appointment {
    id
    folio_number
    pet_id
    pet_name
    customer_id
    veterinarian_id
    consulting_room_id
    status
    appointment_kind
    chief_complaint
    scheduled_start_at
    scheduled_end_at
    duration_minutes
    allow_overlap
    rescheduled_from_appointment_id
    rescheduled_to_appointment_id
    sale_order_id
    clinical_visit_id
  }
`;

export const APPOINTMENTS_QUERY = gql`
  ${APPOINTMENT_FIELDS}
  query Appointments(
    $from: DateTime
    $to: DateTime
    $veterinarian_id: ID
    $consulting_room_id: ID
    $status: String
    $branch_id: ID
  ) {
    appointments(
      from: $from
      to: $to
      veterinarian_id: $veterinarian_id
      consulting_room_id: $consulting_room_id
      status: $status
      branch_id: $branch_id
    ) {
      ...AppointmentFields
    }
  }
`;

export const APPOINTMENTS_CHECKED_IN_QUERY = gql`
  query AppointmentsCheckedIn($branch_id: ID) {
    appointmentsCheckedIn(branch_id: $branch_id) {
      id
      folio_number
      sale_order_id
      pet_name
      veterinarian_id
      scheduled_start_at
    }
  }
`;

export const VETERINARIAN_USERS_QUERY = gql`
  query VeterinarianUsers {
    veterinarianUsers {
      id
      full_name
      professional_license
      photo_url
    }
  }
`;

export const APPOINTMENTS_FOR_PET_QUERY = gql`
  query AppointmentsForPet($pet_id: ID!) {
    appointmentsForPet(pet_id: $pet_id) {
      id
      status
      scheduled_start_at
    }
  }
`;

export const APPT_CONSULTING_ROOMS_QUERY = gql`
  query ApptConsultingRooms {
    consultingRooms(limit: 100, offset: 0) {
      items {
        id
        name
      }
    }
  }
`;

export const BOOK_APPOINTMENT_MUTATION = gql`
  ${APPOINTMENT_FIELDS}
  mutation BookAppointment($input: BookAppointmentInput!) {
    bookAppointment(input: $input) {
      ...AppointmentFields
    }
  }
`;

export const CONFIRM_APPOINTMENT_MUTATION = gql`
  ${APPOINTMENT_FIELDS}
  mutation ConfirmAppointment($appointment_id: ID!, $veterinarian_id: ID, $consulting_room_id: ID) {
    confirmAppointment(
      appointment_id: $appointment_id
      veterinarian_id: $veterinarian_id
      consulting_room_id: $consulting_room_id
    ) {
      ...AppointmentFields
    }
  }
`;

export const CHECKIN_APPOINTMENT_MUTATION = gql`
  ${APPOINTMENT_FIELDS}
  mutation CheckInAppointment($appointment_id: ID!) {
    checkInAppointment(appointment_id: $appointment_id) {
      ...AppointmentFields
    }
  }
`;

export const START_APPOINTMENT_MUTATION = gql`
  ${APPOINTMENT_FIELDS}
  mutation StartAppointment($appointment_id: ID!) {
    startAppointment(appointment_id: $appointment_id) {
      ...AppointmentFields
    }
  }
`;

export const COMPLETE_APPOINTMENT_MUTATION = gql`
  ${APPOINTMENT_FIELDS}
  mutation CompleteAppointment($appointment_id: ID!) {
    completeAppointment(appointment_id: $appointment_id) {
      ...AppointmentFields
    }
  }
`;

export const NOSHOW_APPOINTMENT_MUTATION = gql`
  ${APPOINTMENT_FIELDS}
  mutation MarkAppointmentNoShow($appointment_id: ID!) {
    markAppointmentNoShow(appointment_id: $appointment_id) {
      ...AppointmentFields
    }
  }
`;

export const CANCEL_APPOINTMENT_MUTATION = gql`
  ${APPOINTMENT_FIELDS}
  mutation CancelAppointment($input: CancelAppointmentInput!) {
    cancelAppointment(input: $input) {
      ...AppointmentFields
    }
  }
`;

export const RESCHEDULE_APPOINTMENT_MUTATION = gql`
  ${APPOINTMENT_FIELDS}
  mutation RescheduleAppointment($input: RescheduleAppointmentInput!) {
    rescheduleAppointment(input: $input) {
      ...AppointmentFields
    }
  }
`;
